import { render } from "./AddProduction.vue?vue&type=template&id=070bc784&scoped=true"
import script from "./AddProduction.vue?vue&type=script&lang=js"
export * from "./AddProduction.vue?vue&type=script&lang=js"

import "./AddProduction.vue?vue&type=style&index=0&id=070bc784&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070bc784"]])

export default __exports__